import React from 'react'
import SelectTableFilter from 'components/atoms/select-table-filter'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import {
  BANK_TRANSACTION_CATEGORIES,
  BANK_TRANSACTION_CASH_FLOWS
} from 'domains/bank-transaction'
import {
  BankTransactionCategoryBadge,
  BankTransactionCashFlowBadge
} from 'domains/bank-transaction'
import PriceUtil from 'utils/price-util'
import { Link } from 'react-router-dom'
import TimeUtil from 'utils/time-util'

const customCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original          : PropTypes.object,
      index             : PropTypes.number,
      toggleRowSelected : PropTypes.func
    })
  })
}

/**
 * Defined column to show selected ::Finances::BankTransaction to ops
 * @param {Array} handleRemoveRow - function to uncheck/unselect Customer::Order
 */

const bankTransactionSelectedTableColumns = ({ handleRemoveRow }) => {
  const IndexCell     = ({ cell: { row } }) => (
    <Link to={ `/app/finance/bank-transactions/${row.original.id}` }>{ row.original.id }</Link>
  )
  IndexCell.propTypes = customCellPropTypes

  const TransferDateCell = (row) => TimeUtil.format( row.cell.value )

  // eslint-disable-next-line react/prop-types
  const CashFlowFilter = ({ column }) => {
    const options = Object.keys(BANK_TRANSACTION_CASH_FLOWS).map((key) => (
      {
        label : BANK_TRANSACTION_CASH_FLOWS[key],
        value : BANK_TRANSACTION_CASH_FLOWS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const CashFlowCell = (row) => <BankTransactionCashFlowBadge status={ row.cell.value } />

  // eslint-disable-next-line react/prop-types
  const CategoryFilter = ({ column }) => {
    const options = Object.keys(BANK_TRANSACTION_CATEGORIES).map((key) => (
      {
        label : BANK_TRANSACTION_CATEGORIES[key],
        value : BANK_TRANSACTION_CATEGORIES[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const CategoryCell = (row) => <BankTransactionCategoryBadge category={ row.cell.value } />

  const OrdersCell = (row) => {
    const orders       = row.cell.value
    const isOrderEmpty = orders.length < 1

    if (isOrderEmpty) return (<span>{ '-' }</span>)

    return (
      <>
        {
          orders.map((order) => (
            <li className='mb-1' key={ `order-${order.number}` }>{ order.number }</li>
          ))
        }
      </>
    )
  }

  const AmountCell = (row) => PriceUtil.format(row.cell.value)

  const ActionCell = ({ cell: { row } }) => {
    const data = row.original

    const removeRow = () => handleRemoveRow(data)

    return (
      <Button
        color='danger'
        tag={ Link }
        size='sm'
        onClick={ removeRow }
      >
        { 'Unselect' }
      </Button>
    )
  }
  ActionCell.propTypes = customCellPropTypes

  return (
    [
      {
        Header         : 'Id',
        accessor       : 'index',
        disableFilters : true,
        Cell           : IndexCell
      },
      {
        Header   : 'Bank',
        accessor : 'tl_bank.bank'
      },
      {
        Header   : <>Bank Account<br/>Number</>,
        accessor : 'tl_bank.account_number'
      },
      {
        Header         : <>Transfer<br/>Date</>,
        accessor       : 'transfer_date',
        Cell           : TransferDateCell,
        disableFilters : true
      },
      {
        Header   : <>Cash<br/>Flow</>,
        accessor : 'cash_flow',
        Filter   : CashFlowFilter,
        Cell     : CashFlowCell
      },
      {
        Header   : 'Category',
        accessor : 'category',
        Filter   : CategoryFilter,
        Cell     : CategoryCell
      },
      {
        Header     : 'Description',
        accessor   : 'description',
        minWidth   : 500,
        whiteSpace : 'break-spaces'
      },
      {
        Header         : <>Order<br/>Numbers</>,
        accessor       : 'orders',
        disableFilters : true,
        Cell           : OrdersCell
      },
      {
        Header   : 'Amount',
        accessor : 'amount',
        Cell     : AmountCell
      },
      {
        Header         : 'Action',
        accessor       : 'id',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

export default bankTransactionSelectedTableColumns
